// extracted by mini-css-extract-plugin
module.exports =  {"toggle":"EditPipelineToggle__toggle--Zx"};